import { atom } from "recoil"

const selectedAirlineIdAtom = atom<null | number>({
    default: null,
    key: 'selectedAirlineIdAtomKey'
})

export default selectedAirlineIdAtom;